export default function IntroSection() {
  const recommendations = [
    '日常生活に介助が必要な方',
    '一人暮らしで家事が困難な方',
    '退院後の生活に不安がある方',
    'ご家族の介護負担を軽減したい方',
    '住み慣れた自宅で生活を続けたい方'
  ];

  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12 text-center">
          訪問介護とは
        </h2>

        <div className="space-y-8 text-lg text-gray-700 leading-relaxed mb-12">
          <p>
            訪問介護とは、介護福祉士や訪問介護員（ホームヘルパー）がご自宅を訪問し、日常生活に必要な介護サービスを提供する制度です。
          </p>
          <p>
            要介護認定を受けた方が、住み慣れたご自宅で安心して生活を続けられるよう、身体介護や生活援助などのサポートを行います。ご利用者様の状態やご希望に合わせて、必要なサービスを組み合わせてご提供いたします。
          </p>
          <p>
            私たちまごころヘルパーは、単なる介護サービスの提供にとどまらず、ご利用者様一人ひとりの生活スタイルや価値観を尊重し、その方らしい生活を支えることを大切にしています。
          </p>
        </div>

        <div className="bg-cyan-50 rounded-3xl p-10">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
            <i className="ri-checkbox-circle-line text-cyan-600"></i>
            こんな方におすすめ
          </h3>
          <ul className="space-y-4">
            {recommendations.map((item, index) => (
              <li key={index} className="flex items-start gap-3 text-gray-700">
                <i className="ri-check-line text-2xl text-cyan-600 flex-shrink-0"></i>
                <span className="text-lg">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
